import { clampNumber } from "atlas_forecasting_app/lib/math"

export function ChartTooltip({ tooltip, containerWidth, containerHeight }) {
  if (!tooltip) return null

  const estWidth = 320
  const estHeight = tooltip.title?.length > 34 ? 118 : 102
  const left = clampNumber(tooltip.x + 12, 10, Math.max(10, containerWidth - estWidth - 10))
  const top = clampNumber(tooltip.y + 12, 10, Math.max(10, containerHeight - estHeight - 10))

  return (
    <div className="af-chart-tooltip" style={{ left: `${left}px`, top: `${top}px` }}>
      <div className="af-chart-tooltip-title">{tooltip.title}</div>
      <div className="af-chart-tooltip-body">{tooltip.body}</div>
    </div>
  )
}
